import * as types from './mutation_types'

const defaultState = () => {
	return {
		showFilter: false,
		filter: null
	}
}

export default {
	[types.TOGGLE_SHOW_FILTER](state) {
		state.showFilter = !state.showFilter
	},
	[types.SET_FILTER](state, filter) {
		state.filter = Object.assign({}, filter)
	},
	[types.RESET_STATE](state) {
		const s = defaultState()
		Object.keys(s).forEach(key => {
			state[key] = s[key]
		})
	}
}
